export const types = {
	WEB_TEXT_INPUT: 'WEB_TEXT_INPUT',
	REFRESH_TEXT_INPUT: 'REFRESH_TEXT_INPUT',
	DOWNLOAD_ADDINS_SHOW: 'DOWNLOAD_ADDINS_SHOW',
};
